import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import { getValueIfPropertyExistsInObject } from 'utils/helpers';

const propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  emptyTextKey: PropTypes.string,
  margin: PropTypes.bool,
  explanationTextKey: PropTypes.string,
};

const emptyValue = '';

const itemTitle = (item) => {
  if (item.intl) {
    const intl = useIntl();
    return intl.formatHTMLMessage({ id: item.title });
  }
  return getValueIfPropertyExistsInObject(item, 'title') || getValueIfPropertyExistsInObject(item, 'type') || getValueIfPropertyExistsInObject(item, 'name');
};

const InputSelectField = (props) => {
  const {
    input,
    meta: { touched, error, pristine },
    options,
    disabled,
    isFullWidth,
    margin,
    emptyTextKey,
    explanationTextKey,
  } = props;
  const inputValue = input.value || emptyValue;
  const inputClasses = cx({
    'select-field': true,
    'select-field--state-active': inputValue && inputValue !== emptyValue,
    'select-field--state-error': (touched || !pristine) && error,
    'select-field--state-disabled': disabled,
    'select-field--width-full': isFullWidth,
    'select-field--margin': margin,
  });
  const intl = useIntl();
  const title = intl.formatHTMLMessage({ id: emptyTextKey });
  const currentOption = options.find((item) => `${item.type}` === inputValue || `${item.name}` === inputValue);
  return (
    <>
      <span className={inputClasses}>
        <span className="select-field__title">{title}</span>
        <span className="select-field__field">
          {currentOption && itemTitle(currentOption, intl)}
        </span>
        <select
          className="select-field__field select-field__field--pseudo"
          {...input}
          value={inputValue}
        >
          <option value={emptyValue} disabled>{title}</option>
          {options.map((item) => {
            // eslint-disable-next-line no-prototype-builtins
            const value = getValueIfPropertyExistsInObject(item, 'type') || getValueIfPropertyExistsInObject(item, 'name');

            return (
              <option value={value} key={value} disabled={item.disabled}>
                {itemTitle(item, intl)}
              </option>
            );
          })}
        </select>
      </span>
      {explanationTextKey
        && (
          <span className="input-explanation">
            <FormattedMessage
              id={explanationTextKey}
            />
          </span>
        )}
    </>
  );
};

InputSelectField.propTypes = propTypes;

export default InputSelectField;
